var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"breadcrumb is-small is-left",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',_vm._l((_vm.trail),function(data,index){return _c('li',{key:index,class:{'is-active': !data.showLink}},[_c('router-link',{attrs:{"to":data.showLink ? data.link : '#',"aria-current":data.showLink ? '': 'page'}},[_vm._v(_vm._s(_vm.$t(data.name)))])],1)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8feade4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumbs/Index.vue
// module id = 180
// module chunks = 0